const API_BASE = process.env.REACT_APP_API_URL || '';

export async function getIntegrationStatus(orgId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/integrations/energyhub/status`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch EnergyHub status');
  }
  
  return response.json();
}

export async function testConnection(orgId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/integrations/energyhub/test`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    throw new Error('Connection test failed');
  }
  
  return response.json();
}

export async function triggerSync(orgId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/integrations/energyhub/sync`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    throw new Error('Sync trigger failed');
  }
  
  return response.json();
}
